import { useEffect } from "react";
import { useStore } from "../store";
import { send } from "../ws/singleton";
import { departures } from "./participants";

const EVENT = "ACTIVITY_INSTANCE_PARTICIPANTS_UPDATE";
const ids = (participants: readonly { id: string }[]) => new Set(participants.map((p) => p.id));

/**
 * Listens to Discord's list of who is in this Activity and tells the table when a seated player
 * drops out of it (slice 0024, 0001 S4). Outside Discord there is no list and nothing is sent.
 */
export function useDepartureReports(): void {
  const sdk = useStore((s) => s.sdk);
  useEffect(() => {
    if (sdk === null) return;
    let before: ReadonlySet<string> | null = null;
    const update = ({ participants }: { participants: readonly { id: string }[] }) => {
      const after = ids(participants);
      const { snapshot, member } = useStore.getState();
      if (before !== null && snapshot !== null) {
        const left = departures(before, after, snapshot, member?.userId ?? "");
        if (left.length > 0) send({ type: "departed", userIds: left });
      }
      before = after;
    };
    void sdk.commands
      .getInstanceConnectedParticipants()
      .then(({ participants }) => {
        before ??= ids(participants);
      })
      .catch(() => undefined);
    void sdk.subscribe(EVENT, update).catch(() => undefined);
    return () => {
      void sdk.unsubscribe(EVENT, update).catch(() => undefined);
    };
  }, [sdk]);
}
